
import APIServicesModule from 'api-services/api-services.module';

import PreferencesService from './preferences.service';
import ProviderAccountsService from './provider-accounts.service';
import SheetsService from './sheets.service';
import SubscriptionService from './subscription.service';
import UserService from './user.service';
import ConversionService from './conversion.service';

export const moduleName = 'Tiller.CoreServices';
export default {
  moduleName
};

angular
  .module(
    moduleName,
    [APIServicesModule.moduleName]
  )
  .service(     'PreferencesService', PreferencesService)
  .service('ProviderAccountsService', ProviderAccountsService)
  .service(          'SheetsService', SheetsService)
  .service(    'SubscriptionService', SubscriptionService)
  .service(            'UserService', UserService)
  .service(      'ConversionService', ConversionService);
